/**
 *
 * @param {*} color
 * @param {*} midValue Number from 0-255
 * @returns
 */
function getColorLightness(color, midValue) {
  // Variables for red, green, blue values
  var r, g, b, hsp;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if ((midValue && hsp > midValue) || hsp > 180) {
    return 'light';
  } else {
    return 'dark';
  }
}

const RISK_COLORS = {
  critical: '#FF9FAA', // Brighter Pastel Pink
  Critical: '#FF9FAA',
  CRITICAL: '#FF9FAA',

  high: '#FFD19F', // Brighter Pastel Orange
  High: '#FFD19F',
  HIGH: '#FFD19F',

  medium: '#FFEB9F', // Brighter Pastel Yellow - much more visible!
  Medium: '#FFEB9F',
  MEDIUM: '#FFEB9F',

  low: '#A8E6CF', // Pastel Green
  Low: '#A8E6CF',
  LOW: '#A8E6CF',

  no_risk: '#A5D6A7', // Light green

  INFO: '#9FD4FF', // Brighter Pastel Blue
  info: '#9FD4FF',
  Info: '#9FD4FF',

  UNTRIAGED: '#F8BBD9', // Very light pastel pink/off-white
  Untriaged: '#F8BBD9',
  untriaged: '#F8BBD9',

  warning: '#FFAB91', // Light orange
  Warning: '#FFAB91',
  WARNING: '#FFAB91',

  UNKNOWN: '#a0aec0',
  unknown: '#a0aec0',
  Unknown: '#a0aec0',

  'Clean Images': '#a0aec0',

  ALL: '#405877',
  all: '#405877',
  All: '#405877',
};

const RISK_COLORS_PASTEL = {
  critical: '#F58C8C',
  Critical: '#F58C8C',
  CRITICAL: '#F58C8C',

  high: '#F9A7A7',
  High: '#F9A7A7',
  HIGH: '#F9A7A7',

  medium: '#FFD980',
  Medium: '#FFD980',
  MEDIUM: '#FFD980',

  low: '#F6F07A',
  Low: '#F6F07A',
  LOW: '#F6F07A',

  no_risk: '#89EAA0',

  INFO: '#92ACFF',
  info: '#92ACFF',
  Info: '#9BB7FF',

  UNTRIAGED: '#BCE3F6',
  Untriaged: '#BCE3F6',
  untriaged: '#BCE3F6',

  warning: '#F78E8E',
  Warning: '#F78E8E',
  WARNING: '#F78E8E',

  UNKNOWN: '#B8C6D2',
  unknown: '#B8C6D2',
  Unknown: '#B8C6D2',

  ALL: '#98A7AF',
  all: '#98A7AF',
  All: '#98A7AF',
};

const RANDOM_LABEL_COLORS = [
  '#476ffc',
  '#194bfb',
  '#143cc9',
  '#03bb34',
  '#02962a',
  '#02701f',
  '#6f57e5',
  '#5a44c9',
  '#f62121',
  '#c51a1a',
  '#941414',
  '#baa911',
  '#93802c',
];

const COMPLIANCE_COLORS = {
  passed: '#A8E6CF', // Pastel Green - for passed/compliant
  failed: '#FF9FAA', // Brighter Pastel Pink - for failed/non-compliant
  not_applicable: '#B39DDB', // Soft light lavender/pastel purple - for not applicable
  non_evaluavated: '#A0AEC0', // Keep existing gray for non-evaluated
};

// const RANDOM_COLORS = [
//   '#476FFC',
//   '#35C95D',
//   '#BD47FB',
//   '#7593FD',
//   '#F62121',
//   '#E9D415',
//   '#FFA825',
//   '#194BFB',
//   '#03BB34',
//   '#936DFF',
//   '#B34D4D',
//   '#80B300',
//   '#809900',
//   '#E6B3B3',
//   '#6680B3',
//   '#66991A',
//   '#FF99E6',
//   '#CCFF1A',
//   '#FF1A66',
//   '#E6331A',
//   '#33FFCC',
//   '#66994D',
//   '#B366CC',
//   '#4D8000',
//   '#B33300',
//   '#CC80CC',
//   '#66664D',
//   '#991AFF',
//   '#E666FF',
//   '#4DB3FF',
//   '#1AB399',
//   '#E666B3',
//   '#33991A',
//   '#CC9999',
//   '#B3B31A',
//   '#00E680',
//   '#4D8066',
//   '#809980',
//   '#E6FF80',
//   '#1AFF33',
//   '#999933',
//   '#FF3380',
//   '#CCCC00',
//   '#66E64D',
//   '#4D80CC',
//   '#9900B3',
//   '#E64D66',
//   '#4DB380',
//   '#FF4D4D',
//   '#99E6E6',
//   '#6666FF',
// ];

const RANDOM_COLORS = [
  '#A8B9F5', // base #476FFC
  '#9BE2B3', // base #35C95D
  '#D5A6F7', // base #BD47FB
  '#B5C4FA', // base #7593FD
  '#F7A8A8', // base #F62121
  '#F6E68C', // base #E9D415
  '#FFD199', // base #FFA825
  '#A8B9F5', // base #194BFB
  '#90E0A7', // base #03BB34
  '#C3AEFF', // base #936DFF
  '#E0A6A6', // base #B34D4D
  '#C4D98A', // base #80B300
  '#C6D28A', // base #809900
  '#F2CACA', // base #E6B3B3
  '#B6C6DF', // base #6680B3
  '#B7D989', // base #66991A
  '#FFBEEA', // base #FF99E6
  '#E3F8A6', // base #CCFF1A
  '#F7A0B8', // base #FF1A66
  '#F5B0A0', // base #E6331A
  '#A7F3E4', // base #33FFCC
  '#B8D9A4', // base #66994D
  '#D9B8F0', // base #B366CC
  '#B8D99F', // base #4D8000
  '#E5A893', // base #B33300
  '#E5B8E5', // base #CC80CC
  '#C2C2B0', // base #66664D
  '#CCAAFF', // base #991AFF
  '#F0B3FF', // base #E666FF
  '#A6D9FF', // base #4DB3FF
  '#9DE6D2', // base #1AB399
  '#F0A6D0', // base #E666B3
  '#A4D9A1', // base #33991A
  '#E0C1C1', // base #CC9999
  '#DDD693', // base #B3B31A
  '#99F0C9', // base #00E680
  '#A8CDBD', // base #4D8066
  '#C2D4C2', // base #809980
  '#F2F7B2', // base #E6FF80
  '#A6F5B5', // base #1AFF33
  '#D4D493', // base #999933
  '#F7A6C4', // base #FF3380
  '#F2F2A0', // base #CCCC00
  '#B7F0A6', // base #66E64D
  '#A6C4E6', // base #4D80CC
  '#C99EDC', // base #9900B3
  '#F2A0B8', // base #E64D66
  '#A6E6C4', // base #4DB380
  '#F5A6A6', // base #FF4D4D
  '#B8F0F0', // base #99E6E6
  '#A8A8F5', // base #6666FF
];

// function shuffleArray(array) {
//   for (let i = array.length - 1; i > 0; i--) {
//     const j = Math.floor(Math.random() * (i + 1));
//     [array[i], array[j]] = [array[j], array[i]];
//   }
//   return array;
// }

// const shuffledColors = shuffleArray([...RANDOM_COLORS]);

export { getColorLightness, RANDOM_LABEL_COLORS, RISK_COLORS, RISK_COLORS_PASTEL, COMPLIANCE_COLORS, RANDOM_COLORS };
